module.exports = __webpack_public_path__ + "static/Rajdhani-Regular-fb987593d286bb6bd93d3de8457c5eb4.ttf";